var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canShow),expression:"canShow"}],staticClass:"btn-jump",on:{"click":function($event){$event.stopPropagation();return _vm.launchByScheme.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }